import PropTypes from 'prop-types';
import React from 'react';

import { formatCurrencyNumber } from '../../../../lib/numberFormatter';
import OfferFAQItem from '../OfferFAQItem';

import './index.scss';

const OfferFAQ = ({
  applicationId,
  customerGuid,
  restOfWorld,
  processingFee,
  hasLivingExpense,
}) => {
  const faqItems = [
    [
      'What will happen after accepting the offer?',
      'You will need to upload documents to verify the information you provided in your application.',
    ],
    [
      'Can I change the loan amount after accepting the provisional offer?',
      'Yes, you can change the loan amount or withdraw your application entirely by contacting our customer service team.',
    ],
    [
      'When can I get a loan confirmation letter for visa purposes?',
      `Once your documents are verified, you will need to pay $${formatCurrencyNumber(
        processingFee,
      )} loan confirmation fee before receiving your loan confirmation letter.`,
    ],
    [
      'When can I start repaying back my loan?',
      'You only have to start repaying your loan 6 months after you finish classes, but you can start repaying it as soon as the loan is disbursed.',
    ],
  ];

  if (restOfWorld) {
    faqItems.push([
      'How will I receive the money?',
      'The loan for tuition fees will be paid directly to your school, while the loan for living expenses will be deposited directly into your bank account.',
    ]);
  } else {
    faqItems.push([
      'How will I receive the money?',
      'The loan for tuition fees and living expenses will be paid directly to your school.',
    ]);
  }

  return (
    <section className="offer-faq">
      <h3 className="section-title">Frequently asked questions</h3>
      <div className="offer-faq__list">
        {faqItems.map(([question, answer], index) => (
          <div key={index}>
            <OfferFAQItem
              question={question}
              answer={answer}
              applicationId={applicationId}
              customerGuid={customerGuid}
            />
            {index !== faqItems.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </section>
  );
};

OfferFAQ.defaultProps = {
  hasLivingExpense: false,
};

OfferFAQ.propTypes = {
  applicationId: PropTypes.string.isRequired,
  customerGuid: PropTypes.string.isRequired,
  restOfWorld: PropTypes.bool.isRequired,
  hasLivingExpense: PropTypes.bool,
};

export default OfferFAQ;
